/**
 * Default theme that loads when no user preference is set
 * Change this value to set a different default theme
 */
export const DEFAULT_THEME = 'vercel';

export const THEMES = [
  {
    name: 'Claude',
    value: 'claude'
  },
  {
    name: 'Neobrutualism',
    value: 'neobrutualism'
  },
  {
    name: 'Supabase',
    value: 'supabase'
  },
  {
    name: 'Vercel',
    value: 'vercel'
  },
  {
    name: 'Mono',
    value: 'mono'
  },
  {
    name: 'Notebook',
    value: 'notebook'
  }
];
